<script>
	export let title = "MataFome Desktop";

	function handleMinimize() {
		if (typeof window !== "undefined") {
			if (window.desktop && window.desktop.minimize) window.desktop.minimize();
			else if (window.ipcRenderer) window.ipcRenderer.send("window-minimize");
		}
	}

	function handleMaximize() {
		if (typeof window !== "undefined") {
			if (window.desktop && window.desktop.maximize) window.desktop.maximize();
			else if (window.ipcRenderer) window.ipcRenderer.send("window-maximize");
		}
	}

	function handleClose() {
		if (typeof window !== "undefined") {
			if (window.desktop && window.desktop.close) window.desktop.close();
			else if (window.ipcRenderer) window.ipcRenderer.send("window-close");
		}
	}
</script>

<div class="custom-titlebar">
	<div class="title-left">
		<span class="app-name">Mata<span class="highlight">Fome</span></span>
		<span class="app-sub">Desktop</span>
	</div>

	<!-- Área de arraste da janela nativa e limpa -->
	<div class="title-center"></div>

	<div class="window-controls">
		<button class="win-btn minimize" on:click={handleMinimize} title="Minimizar">
			<svg width="10" height="1" viewBox="0 0 10 1"><rect width="10" height="1" fill="currentColor"/></svg>
		</button>
		<button class="win-btn maximize" on:click={handleMaximize} title="Maximizar">
			<svg width="10" height="10" viewBox="0 0 10 10"><rect width="9" height="9" x="0.5" y="0.5" fill="none" stroke="currentColor"/></svg>
		</button>
		<button class="win-btn close" on:click={handleClose} title="Fechar">
			<svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.2"/></svg>
		</button>
	</div>
</div>

<style>
	.custom-titlebar {
		height: 32px;
		background: #0B0E14;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 0 0 12px;
		user-select: none;
		-webkit-app-region: drag;
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
		font-size: 12px;
		z-index: 1000;
	}

	.title-left {
		display: flex;
		align-items: center;
		gap: 8px;
		font-weight: 600;
	}

	.app-logo-badge {
		width: 18px;
		height: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.mascot-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.app-name {
		color: #FFFFFF;
		font-weight: 700;
		letter-spacing: -0.2px;
		font-size: 12px;
	}

	.app-name .highlight {
		color: #FF6A00;
	}

	.app-sub {
		font-size: 11px;
		color: #64748B;
		font-weight: 500;
	}

	.title-center {
		flex: 1;
		height: 100%;
	}

	.window-controls {
		display: flex;
		height: 100%;
		-webkit-app-region: no-drag;
	}

	.win-btn {
		width: 44px;
		height: 100%;
		background: none;
		border: none;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.win-btn:hover {
		background: rgba(255, 255, 255, 0.08);
		color: #FFFFFF;
	}

	.win-btn.close:hover {
		background: #E11D48;
		color: #FFFFFF;
	}
</style>
